import { nanoid } from "@reduxjs/toolkit";
import { useToast } from "fds";
import { useTranslation } from "react-i18next";

export default function useStartDownload() {
  const toast = useToast();
  const { t } = useTranslation();
  const startDownload = (loaded: number): void => {
    if (loaded > 50000000) {
      toast.toastMsg(nanoid(), t("file.alert.downloadBigFile"), "success");
    }
    return;
  };

  return startDownload;
}
